import script from "./Files.vue?vue&type=script&setup=true&lang=js"
export * from "./Files.vue?vue&type=script&setup=true&lang=js"

import "./Files.vue?vue&type=style&index=0&id=067c7a8d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-067c7a8d"]])

export default __exports__